import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { AuthContext } from '../../utilities/auth-context';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

// MUI Components
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

// Components
// import TextField from '../form-fields/text-field';


const Login = ({ onAuthenticate }) => {

    const { dispatch } = useContext(AuthContext);

    const [email, setEmail]                     = useState('');
    const [password, setPassword]               = useState('');
    
    const loginAttempt = ( event ) => {
        event.preventDefault();
        if( ! validate() ) {
            return;
        }
        const data = new FormData(event.currentTarget);
        axios.post( '/login', data ).then( response => {
            if( response.status === 200 && !response.data.error ){
                dispatch({ type: 'LOGIN', payload: response.data });
                onAuthenticate( true );
            }
            else{
                toast.error( response.data.error );
            } 
        });
    }

    const validate = () => {
        if( ! email || ! password ) {
            toast.error('Please enter your credentials');
            return false;
        }
        return true;
    }

    useEffect(() => {
        if( localStorage.getItem('remember_me') ) {
            setUsername(localStorage.getItem('remember_me'));
        }
    }, []);
    
    return (
        <Container className='login-form-container auth-form-container' maxWidth="sm">
            <Box className='login-form-title'>
                <h1>Simple Monitoring Admin</h1>
            </Box>
            <Box component='form' className='login-form' onSubmit={loginAttempt}>
                <TextField
                    variant='outlined'
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    autoFocus
                    onChange={e => setEmail(e.target.value)}
                />
                <TextField
                    variant='outlined'
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    onChange={e => setPassword(e.target.value)}
                />
                <br/><br/>
                <Button 
                    variant='contained' 
                    color='primary'
                    type='submit'
                >
                    Continue
                </Button>
            </Box>
        </Container>
    );

}

export default Login;